import type { TrainingScheduleOperationsItem } from "@/api/trainingSchedule";
import { notifyWindowCapReached, windowStack } from "@/app/windowStack";

// scheduleOccurrences kind 엔트리의 params 계약. 콘텐츠(ScheduleOccurrencesWindowContent)가 읽고,
// 목록 행 클릭이 open 할 때 채운다. 여는 시점의 Schedule 스냅샷이다(제목·상태 칩용). 실행 이력은
// 창이 API 로 받는다.
export type ScheduleOccurrencesWindowParams = {
  schedule: TrainingScheduleOperationsItem;
};

// Schedule 실행 이력을 전체 화면 창 스택으로 연다(목록 행 클릭). 같은 Schedule 창이 이미 열려
// 있으면 그 창을 복원한다. cap(5)을 넘으면 열지 않고 toast 로 안내한다.
export function openScheduleOccurrencesWindow(schedule: TrainingScheduleOperationsItem): void {
  const id = windowStack.open({
    kind: "scheduleOccurrences",
    key: schedule.id,
    title: schedule.name,
    params: { schedule } satisfies ScheduleOccurrencesWindowParams,
  });
  if (id === null) {
    notifyWindowCapReached();
  }
}

// 열린 이력 창의 스냅샷(제목·상태 칩)을 목록의 최신 행으로 맞춘다. 그래서 이름을 바꾸거나
// 일시정지·삭제한 뒤에도 창이 이전 이름과 상태를 표시하지 않는다. 창이 없으면 아무것도 하지 않는다.
export function syncScheduleOccurrencesWindow(schedule: TrainingScheduleOperationsItem): void {
  const entry = windowStack.entryOf("scheduleOccurrences", schedule.id);
  if (entry === undefined) {
    return;
  }
  windowStack.update(entry.id, {
    title: schedule.name,
    params: { schedule } satisfies ScheduleOccurrencesWindowParams,
  });
}
